import { mutateWithVariables, queryWithVariables } from '@/services/api/api';
import { deleteFileFromAzure } from '@/utils/file';
/* eslint-disable @typescript-eslint/no-explicit-any*/

export const createProductFormBuilder = async (payload: { productId: number; formFields: string }): Promise<any> => {
  const result = await mutateWithVariables(
    `
        mutation CreateProductFormBuilder($productFormBuilder: ProdFormBuilderInput!){
          addProductFormBuilder(input: $productFormBuilder) {        
            productId,
            formFields
          }
        }
      `,
    {
      productFormBuilder: payload,
    }
  );
  return result.data;
};

export const getProductFormBuilder = async (productId: number): Promise<any> => {
  try {
    const result = await queryWithVariables(
      `
      query($productIds: [Long!]) {
        productFormBuilder(ids: $productIds) {
          formFields
        }
      }
    `,
      {
        productIds: [productId],
      }
    );
    if (!result.data?.productFormBuilder) return null;
    return result.data?.productFormBuilder?.[0]?.formFields;
  } catch (error) {
    console.error('error', error);
    return null;
  }
};

export const deleteProductFormBuilder = async (productId: number): Promise<any> => {
  try {
    const result = await mutateWithVariables(
      `
      mutation DeleteProductFormBuilder($id: Long!){
        deleteProductFormBuilder(id: $id)
      }
    `,
      {
        id: productId,
      }
    );
    return result.data.deleteProductFormBuilder;
  } catch (error) {
    console.error('error', error);
    return null;
  }
};

const deleteFieldImages = (field: any): void => {
  if (field.image && field.imageType === 'file') {
    deleteFileFromAzure(field.image);
  }

  field.options?.forEach((opt: { image: string; imageType: string; }) => {
    if (opt.image && opt.imageType === 'file') {
      deleteFileFromAzure(opt.image);
    }
  });
};

export const deleteFormBuilderAzureFiles = async (productId: number): Promise<number> => {
  try {
    const res = await getProductFormBuilder(productId);
    const parsedFields: {
      image: string;
      imageType: string;
      options: { image: string; imageType: string }[];
    }[] = JSON.parse(res ?? '[]');

    parsedFields.forEach(deleteFieldImages);

    return 1;
  } catch (err) {
    console.error('err delete azure form builder', err);
    return 0;
  }
}